export default __webpack_public_path__ + "static/media/assemble.b5ec7891.jpg";